/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable functional/immutable-data */
/* eslint-disable functional/no-conditional-statement */

type OurCookies = {
  readonly MkHcOrderId?: string;
  readonly MkHcOrderLineCount?: string;
  readonly MkHcLoggedIn?: string;
  readonly MkHcClientId?: string;
  readonly MkHcCheckClientId?: string;
  readonly MkHcToken?: string;
  readonly MkHcLoggedInToken?: string;
  readonly MkHcLang?: string;
  readonly MkHcCurrencyId?: string;
  readonly mkhcNextIndex?: number;
  readonly MkHcPartnerOriginDomain?: string;
};

/**
 * https://www.geekstrick.com/snippets/how-to-parse-cookies-in-javascript/
 */
export function parseCookie(cookieString: string): OurCookies {
  return cookieString === ""
    ? {}
    : cookieString
      .split(";")
      .map((subString) => subString.split("="))
      .reduce((accumulator: any, [key, value]: any) => {
        const checkKey = decodeURIComponent(key.trim());

        if (checkKey.toLowerCase().startsWith("mkhc")) {
          accumulator[checkKey] = decodeURIComponent(value.trim());
        }

        return accumulator;
      }, {});
}

export function isUserLoggedIn(cookieString: string): boolean {
  const cookies = parseCookie(cookieString);
  return cookies.MkHcLoggedIn === "true";
}

export function getLoggedInToken(): unknown {
  return parseCookie(document.cookie)["MkHcLoggedInToken"];
}
